Backbone = require 'backbone'
Backbone.$ = $

class EmailFormUSLocationSelectPaginationView extends Backbone.View

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @element = @options.paginationElement
    @itemsPerPage = @options.itemsPerPage
    @totalNoOfItems = @options.totalNoOfItems
    @paginationClickHandler = @options.callback

  render: ->
    @element.pagination @totalNoOfItems,
      items_per_page:@itemsPerPage
      callback:@paginationClickHandler
      prev_text : I18n.t('js.modules.support.prev_text')
      next_text : I18n.t('js.modules.support.next_text')

  reRender: ->
    @element.empty()
    @render()

module.exports = EmailFormUSLocationSelectPaginationView
